module.exports = __webpack_public_path__ + "static/media/logo-dev.835e34ed.svg";